import { useEffect, useCallback } from 'react';
import useLockBodyScroll from '../../../hooks/useLockBodyScroll';
import './Lightbox.css';

export default function Lightbox({ items, index, onClose, onNavigate }) {
  const open = index !== null && index !== undefined;
  useLockBodyScroll(open);

  const go = useCallback(
    (dir) => {
      if (!open) return;
      const next = (index + dir + items.length) % items.length;
      onNavigate(next);
    },
    [open, index, items, onNavigate],
  );

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, go, onClose]);

  if (!open) return null;
  const item = items[index];

  return (
    <div className="lightbox" role="dialog" aria-modal="true" aria-label="Image viewer" onClick={onClose}>
      <button className="lightbox__close" onClick={onClose} aria-label="Close">×</button>

      {items.length > 1 && (
        <button
          className="lightbox__nav lightbox__nav--prev"
          onClick={(e) => { e.stopPropagation(); go(-1); }}
          aria-label="Previous image"
        >
          ‹
        </button>
      )}

      <figure className="lightbox__figure" onClick={(e) => e.stopPropagation()}>
        <img src={item.src} alt={item.alt || ''} />
        {item.caption && <figcaption className="lightbox__caption">{item.caption}</figcaption>}
      </figure>

      {items.length > 1 && (
        <button
          className="lightbox__nav lightbox__nav--next"
          onClick={(e) => { e.stopPropagation(); go(1); }}
          aria-label="Next image"
        >
          ›
        </button>
      )}

      {items.length > 1 && (
        <p className="lightbox__count">{index + 1} / {items.length}</p>
      )}
    </div>
  );
}
